import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { DataService } from "../../../_services/data.service";
import { AuthenticationService } from "../../../_services/authentication.service";
import { EventsService } from "../../../_services/eventsServices/events.service";

import { FormControl, FormGroup, Validators } from "@angular/forms";
import { NgbModal, NgbModalRef, NgbTabset } from "@ng-bootstrap/ng-bootstrap";
import { ActivatedRoute, Router } from "@angular/router";

import { devToastMessage } from "../../../_helpers/devToastMessage";
import { parentEventMegaFormValues } from "../../events-screen/tests/fixtures/parentEventMegaFormValues";
import { GenericModalComponent } from "../../../form/generic-app-modal/generic-modal.component";
import { EventValidationService } from "../../../_services/eventsServices/eventValidation.service";
import { TranslationService } from "../../../_services/translation.service";
import { Observable } from "rxjs/Observable";
import { ITranslations } from "../../../_models/ITranslations";
import { UserManagementService } from "../../../_services/user-management.service";
import { AppUserFullModel } from "../user-management-models/app-user.model";
import { UserFormErrorsEnum } from "../user-management-models/user-form-errors.enum";
import { UserManagementFormPersonalDetailsComponent } from "../user-management-form-personal-details/user-management-form-personal-details.component";

@Component({
  selector: "user-management-form",
  templateUrl: "./user-management-form.component.html",
  styleUrls: ["./user-management-form.component.scss"],
})
export class UserManagementFormComponent
  implements OnInit, OnDestroy, AfterViewInit
{
  public layerCollectionGlobalData: any;
  public showPasswordManagement: boolean = false;
  public dataWasLoaded: boolean = false;
  public readonly initialFormValuesOnEdit = {
    israeliId: "",
    email: "",
    phoneNumber: "",
    userName: "",
  };

  @ViewChild("formTabSet") public formTabSet: NgbTabset;
  @Input("modalEventId") public modalUserId: "new" | string;
  @Output("modalAction") public modalAction: EventEmitter<"close" | "save"> =
    new EventEmitter<"close" | "save">();
  public userEditPersonalDetailsForm: FormGroup = new FormGroup({
    israeliId: new FormControl(""),
    email: new FormControl(""),
    firstName: new FormControl("", {
      validators: [
        Validators.required,
        Validators.minLength(2),
        Validators.maxLength(20),
      ],
    }),
    lastName: new FormControl("", { validators: [Validators.required] }),
    phoneNumber: new FormControl(""),
    userName: new FormControl(""), // new FormControl("", {validators: [Validators.required], updateOn: "blur"}),
  });
  public userEditSystemPrivilegesForm: FormGroup = new FormGroup({
    isActive: new FormControl(""),
    isDeleted: new FormControl(""),
    privilegeType: new FormControl(""),
    viewOnly: new FormControl(""),
    cashCollection: new FormControl(""),
    creditCollection: new FormControl(""),
    refundPassWord: new FormControl(""),
  });
  public activityFieldsForm: FormGroup = new FormGroup({
    has_extra_unseen_permission: new FormControl(""),
    userFormLayers: new FormControl([]),
    userSelectedOrgans: new FormControl([]),
    availableOrgans: new FormControl([]),
  });
  public userManagementMegaForm: FormGroup = new FormGroup({
    personalDetails: this.userEditPersonalDetailsForm,
    systemPrivileges: this.userEditSystemPrivilegesForm,
    activityFields: this.activityFieldsForm,
  });
  public isNewUser: boolean = true;
  public disableSave: boolean = false;
  public specificEventName: string = "משתמש"; //
  public translations$: Observable<ITranslations>;
  @ViewChild("personalDetailsFormComponent")
  private personalDetailsFormComponent: UserManagementFormPersonalDetailsComponent;

  constructor(
    protected translationService: TranslationService,
    protected eventsService: EventsService,
    protected dataService: DataService,
    protected userManagementService: UserManagementService,
    protected authenticationService: AuthenticationService,
    protected activatedRoute: ActivatedRoute,
    protected router: Router,
    protected modalService: NgbModal,
    protected changeDetectorRef: ChangeDetectorRef
  ) {
    this.translations$ = this.translationService.translations;
    this.activityFieldsForm.valueChanges.subscribe((value) => {});
  }

  public ngOnInit(): void {
    this.initPage().then();
    this.initUserEditForm(this.modalUserId).then();
    // setInterval(() => {

    // }, 2000);
    // this.initDiscountEditForm(this.modalUserId).then();
    //
    this.userManagementMegaForm.valueChanges.subscribe((value) => {});
  }

  public async devAutoAction() {
    devToastMessage();
    const randNant =
      `${this.specificEventName} ` + Math.floor(Math.random() * 1000);
    const data = parentEventMegaFormValues;
    data.parentEventMain.parentEventDetails.eventName = randNant;
    this.userManagementMegaForm.patchValue(parentEventMegaFormValues);
  }

  public ngAfterViewInit() {
    this.changeDetectorRef.detectChanges();
  }

  public ngOnDestroy(): void {
    this.eventsService.resetAllEditDataData();
  }

  public navigateForm(number: number) {
    const tabNumber = +this.formTabSet.activeId.replace("tab-", "");
    const newTabNumber = tabNumber + number;
    if (number === 1) {
      this.revalidateForm();
    }

    if (newTabNumber < 1 || newTabNumber > 4) {
      return;
    }
    this.formTabSet.select(`tab-${newTabNumber}`);
  }

  public async buildMegaFormObject() {
    const megaFormData = JSON.parse(
      JSON.stringify(this.userManagementMegaForm.value)
    );

    return megaFormData;
  }

  public async submit() {
    const megaFormData = await this.buildMegaFormObject();

    const serializedMegaFormForPost =
      UserManagementService.serializeUserDataToPostData(megaFormData);

    const validationErrors = this.validateMegaForm();

    if (validationErrors.length) {
      this.showValidationErrors(validationErrors);
      return;
    }
    let saveResponse;
    this.disableSave = true;
    if (this.isNewUser) {
      saveResponse = await this.userManagementService.saveNewUser(
        serializedMegaFormForPost,
        this.modalUserId
      );
    } else {
      saveResponse = await this.userManagementService.saveExistingUser(
        serializedMegaFormForPost,
        this.modalUserId
      );
    }

    const modalRef: NgbModalRef = this.modalService.open(GenericModalComponent);
    if (saveResponse.success) {
      modalRef.componentInstance.modalOptions = {
        approveOption: "אישור",
        cancelOption: "",
        modalHeader: "סיום",
        modalText: `  ${serializedMegaFormForPost.first_name}  נשמר בהצלחה!`,
        onlyApprove: true,
      };
      modalRef.result.then((res) => {
        this.closeParentEventModal();
      });
      return;
    } else {
      const isDisconnected =
        saveResponse.error && saveResponse.error.status === 401;

      const errorMessage =
        await EventValidationService.convertServer400ErrorsToReadableText(
          saveResponse.error
        );
      const modalText = isDisconnected
        ? "נותקת מהמערכת עקב חוסר פעילות. התחבר מחדש."
        : ` השמירה נכשלה. פרטים:   ${"\n" + errorMessage}`;
      modalRef.componentInstance.modalOptions = {
        approveOption: "אישור",
        cancelOption: "",
        modalHeader: "שגיאה",
        modalText,
        onlyApprove: true,
      };
      modalRef.result.then((res) => {
        if (isDisconnected) {
          this.closeParentEventModal();
          setTimeout(() => this.router.navigate(["/login"]), 1000);
        }
      });
      this.disableSave = false;
    }
  }

  public async closeParentEventModal() {
    this.modalAction.emit("close");
  }

  public skipAndSave(number: number) {
    this.submit().then();
  }

  protected async initUserEditForm(userId: string) {
    if (!userId && this.modalUserId) {
      userId = this.modalUserId;
    }

    if (userId !== "new") {
      this.isNewUser = false;
      const userData =
        await this.userManagementService.GetUserDataAndEditorDataForEdit(
          userId
        );
      // @ts-ignore
      this.patchFormValues(userData);

      if (!userData) {
        const modalRef: NgbModalRef = this.modalService.open(
          GenericModalComponent
        );
        modalRef.componentInstance.modalOptions = {
          approveOption: "אישור",
          cancelOption: "",
          modalHeader: "שגיאה",
          modalText: ` ${this.specificEventName} ${userId} לא קיים במערכת.  `,
          onlyApprove: true,
        };
        modalRef.result.then((res) => {});
      }
    } else {
      try {
        const userData =
          await this.userManagementService.getCreateUserFormInitialData();
        this.patchFormValues(userData);
      } catch (err) {
        this.handleError(err);
      }
    }
    this.dataWasLoaded = true;
    this.buildMegaForm();
  }

  protected buildMegaForm() {
    // this.userManagementMegaForm.addControl(
    //   "parentEventMain",
    //   this.userEditPersonalDetailsForm
    // );
  }

  protected handleError(err: any) {
    const isDisconnected = err.status === 401;
    const noUserPermission = err.status === 400;
    let modalText = err.toString();
    if (noUserPermission) {
      modalText = `אין לך הרשאה מספקת לערוך את ה${this.specificEventName}   `;
    } else if (isDisconnected) {
      modalText = "נותקת מהמערכת עקב חוסר פעילות. התחבר מחדש.";
    }

    const modalRef: NgbModalRef = this.modalService.open(GenericModalComponent);
    modalRef.componentInstance.modalOptions = {
      approveOption: "אישור",
      cancelOption: "",
      modalHeader: "שגיאה",
      modalText,
      onlyApprove: true,
    };
    modalRef.result.then((res) => {
      this.closeParentEventModal().then((r) => r);
      if (isDisconnected) {
        setTimeout(() => this.router.navigate(["/login"]), 1000);
      }
    });
  }

  protected showValidationErrors(validationErrors: string[]) {
    const modalRef: NgbModalRef = this.modalService.open(GenericModalComponent);
    modalRef.componentInstance.modalOptions = {
      approveOption: "אישור",
      cancelOption: "",
      modalHeader: "שגיאה",
      modalText: `לשם שמירת ה${this.specificEventName}: ${validationErrors.join(
        ", "
      )}`,
      onlyApprove: true,
    };
    modalRef.result.then((res) => {});
  }

  protected validateMegaForm(): string[] {
    const allErrors: any = {};
    const allFormsWithErrors = [
      this.userEditPersonalDetailsForm,
      this.userEditSystemPrivilegesForm,
      this.activityFieldsForm,
    ];
    allFormsWithErrors.forEach((f) => {
      for (const formControl in f.controls) {
        if (f.controls[formControl].invalid) {
          Object.assign(allErrors, f.controls[formControl].errors);
        }
      }
    });
    return Object.entries(allErrors)
      .map(([key, value]) => {
        const errorKey = key as UserFormErrorsEnum;
        if (!value) {
          return null;
        }
        switch (errorKey) {
          case UserFormErrorsEnum.BadEmail:
            return "יש להזין דואל תקין";
          case UserFormErrorsEnum.BadIsraeliId:
            return "יש להזין ת.ז תקינה";
          case UserFormErrorsEnum.BadUserName:
            return "יש להזין שם משתמש תקין ";
          case UserFormErrorsEnum.BadPhoneNumber:
            return "יש להזין טלפון תקין ";
          case UserFormErrorsEnum.BadSystemStatus:
            return "יש להזין הרשאות מערכת תקינות ";
          case UserFormErrorsEnum.BadOrganPrevaliges:
            return "יש להזין שדה פעילות תקין ";
        }
        return null;
      })
      .filter((err) => err);
  }

  protected async initPage() {}

  protected patchFormValues(userData: AppUserFullModel) {
    this.userEditPersonalDetailsForm.patchValue({
      israeliId: userData.israeliId,
      email: userData.email,
      firstName: userData.firstName,
      lastName: userData.lastName,
      phoneNumber: userData.mobileNumber,
      userName: userData.userName,
    });
    if (userData.id) {
      (this.initialFormValuesOnEdit.israeliId = userData.israeliId),
        (this.initialFormValuesOnEdit.email = userData.email);
      this.initialFormValuesOnEdit.phoneNumber = userData.mobileNumber;
      this.initialFormValuesOnEdit.userName = userData.userName;
    }

    this.userEditSystemPrivilegesForm.patchValue({
      isActive: userData.isActive,
      isDeleted: false,
      privilegeType: userData.userPrivilegeType,
      viewOnly: userData.viewOnly,
      cashCollection: userData.cashCollection,
      creditCollection: userData.creditCollection,
      refundPassWord: userData.refundCode,
    });

    this.activityFieldsForm.patchValue({
      userFormLayers: [],
      has_extra_unseen_permission: userData.has_extra_unseen_permission,
      userSelectedOrgans: userData.currentOrgans,
      availableOrgans: userData.availableOrgans,
    });
  }

  private revalidateForm() {
    if (this.personalDetailsFormComponent && this.isNewUser) {
      this.personalDetailsFormComponent.revalidateForm();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/users/user-management-form/user-management-form.component.ts